import React from 'react';

function Footer() {
  return (
    <footer className="bg-slate-700 text-white text-center p-4 mt-4">
      <p className='font-serif'>&copy; 2024 Allure Textiles. All Rights Reserved.</p>
      <p className='font-serif'>Follow us on social media:</p>
      <div>
        <a href="#" className="text-blue-400 mx-2 font-serif">Facebook</a>
        <a href="#" className="text-blue-400 mx-2 font-serif">Instagram</a>
        <a href="#" className="text-blue-400 mx-2 font-serif">Twitter</a>
      </div>
    </footer>
  );
}

export default Footer;

